import React from 'react';
import { OverlayWrapper } from './styles';

const ScannerOverlay = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <OverlayWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={300}
        height={302}
        fill="none"
        {...props}
      >
        <path
          stroke="#005AFF"
          strokeLinecap="round"
          strokeWidth={5}
          d="M3 44V4M3 3h40M297.5 258v40M297.5 299h-40M256.5 3.5h40M297.5 3.5v40M44 298.5H4M3 298.5v-40"
        />
      </svg>
    </OverlayWrapper>
  );
};

export default ScannerOverlay;
